import React, {useState} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';
import {RadioButton} from '../../../atoms/RadioButton/RadioButton';
import {RadioGroup} from '../../../atoms/RadioButton/RadioGroup';
import {SortingOption} from '../types/SortingOption';

interface SortFlyoutSortOptionsProps {
  activeOptionId: string;
  onSelect: (optionId: string) => void;
  options: Array<SortingOption>;
  primaryButtonLabel: string;
  onPrimaryButtonClick: VoidFunction;
}

export const SortFlyoutSortOptions: React.FC<SortFlyoutSortOptionsProps> = ({
  activeOptionId,
  onSelect,
  options,
  primaryButtonLabel,
  onPrimaryButtonClick,
}) => {
  const [value, setValue] = useState(activeOptionId);

  const handlePrimaryButtonClick = () => {
    onSelect(value);
    onPrimaryButtonClick();
  };

  return (
    <>
      <Options>
        {options.map(({id, label}) => (
          <RadioButton
            key={id}
            name="sort"
            label={label}
            value={id}
            checked={id === value}
            onChange={() => setValue(id)}
            data-testid={`sortFlyoutOption-${id}`}
          />
        ))}
      </Options>
      <Footer>
        <PrimaryButton
          onClick={handlePrimaryButtonClick}
          data-testid="sortFlyoutFooterSubmit"
        >
          {primaryButtonLabel}
        </PrimaryButton>
      </Footer>
    </>
  );
};

const Options = styled(RadioGroup)`
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem 2rem;
`;

const Footer = styled.footer`
  height: 5rem;
  width: 100%;
  padding: 0 1rem;
  border-top: 1px solid ${COLORS.Grey3};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const PrimaryButton = styled.button`
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 3rem;
  display: flex;
  background: ${COLORS.Black};
  outline: none;
  border-radius: 3px;
  border: none;
  text-align: center;
  font-weight: ${FONT_WEIGHTS.mediumBold};
  font-size: ${FONT_SIZES.px14};
  color: ${COLORS.White};
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;
